import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import PasswordChangeRequiredPage, { getDefaultData } from "components/pages/PasswordChangeRequiredPage";
import "./styles.css";

/**
 * @name CaptureSoftTokenActivationActivateTokenPasswordChangeConfirmed
 * @returns {React.Component}
 * @description A capture component in the capture group "Soft Tokens - Activation".
 */
export default function CaptureSoftTokenActivationActivateTokenPasswordChangeConfirmed(props) {
    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "newPassword" ], { value: "123456789012" })
    .update([ "confirmNewPassword" ], { value: "123456789012" })
    .submit();

    return <PasswordChangeRequiredPage data={ data } className="capture-soft-token-activation" />;
}